<template>
  <div class="py-4 space-y-6">
    <!-- Title -->
    <div class="text-center mb-6">
      <h1 class="text-xl font-bold text-foreground mb-2">
        {{ $t('report.members_retention_info.title') }}
      </h1>
      <p class="text-sm text-muted-foreground leading-relaxed max-w-xs mx-auto">
        {{ $t('report.members_retention_info.description') }}
      </p>
    </div>

    <!-- How to read -->
    <div class="space-y-4">
      <div class="flex items-center gap-2">
        <div class="w-1 h-3.5 rounded-full" style="background: #06C8FF"></div>
        <h2 class="text-sm font-bold uppercase tracking-wide text-foreground">
          {{ $t('report.members_retention_info.how_to_read') }}
        </h2>
      </div>

      <div class="space-y-3">
        <div class="flex items-start gap-2.5">
          <span class="w-2.5 h-2.5 rounded-full shrink-0 mt-1" style="background: #06C8FF"></span>
          <div>
            <span class="text-xs font-semibold text-foreground">{{ $t('report.members_retention_info.cohort_label') }}</span>
            <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
              {{ $t('report.members_retention_info.cohort_desc') }}
            </p>
          </div>
        </div>

        <div class="flex items-start gap-2.5">
          <span class="w-2.5 h-2.5 rounded-full shrink-0 mt-1" style="background: #10B981"></span>
          <div>
            <span class="text-xs font-semibold text-foreground">{{ $t('report.members_retention_info.offset_label') }}</span>
            <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
              {{ $t('report.members_retention_info.offset_desc') }}
            </p>
          </div>
        </div>

        <div class="flex items-start gap-2.5">
          <span class="w-2.5 h-2.5 rounded-full shrink-0 mt-1" style="background: #EAB308"></span>
          <div>
            <span class="text-xs font-semibold text-foreground">{{ $t('report.members_retention_info.rate_label') }}</span>
            <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
              {{ $t('report.members_retention_info.rate_desc') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Color scale -->
    <div class="space-y-3">
      <div class="flex items-center gap-2">
        <div class="w-1 h-3.5 rounded-full" style="background: #06C8FF"></div>
        <h2 class="text-sm font-bold uppercase tracking-wide text-foreground">
          {{ $t('report.members_retention_info.colors_title') }}
        </h2>
      </div>

      <div class="flex items-center gap-1.5 ml-3">
        <div class="h-5 flex-1 rounded" style="background: rgba(239, 68, 68, 0.45)"></div>
        <div class="h-5 flex-1 rounded" style="background: rgba(249, 115, 22, 0.5)"></div>
        <div class="h-5 flex-1 rounded" style="background: rgba(234, 179, 8, 0.5)"></div>
        <div class="h-5 flex-1 rounded" style="background: rgba(16, 185, 129, 0.65)"></div>
        <div class="h-5 flex-1 rounded" style="background: rgba(5, 150, 105, 0.8)"></div>
      </div>
      <div class="flex justify-between ml-3 text-[9px] text-muted-foreground">
        <span>Min</span>
        <span>Max</span>
      </div>
      <p class="text-xs text-muted-foreground leading-relaxed ml-3">
        {{ $t('report.members_retention_info.colors_desc') }}
      </p>
    </div>

    <!-- M0 explanation -->
    <div class="space-y-2">
      <div class="flex items-center gap-2">
        <div class="w-1 h-3.5 rounded-full" style="background: #06C8FF"></div>
        <h2 class="text-sm font-bold uppercase tracking-wide text-foreground">
          {{ $t('report.members_retention_info.m0_label') }}
        </h2>
      </div>
      <p class="text-xs text-muted-foreground leading-relaxed ml-3">
        {{ $t('report.members_retention_info.m0_desc') }}
      </p>
    </div>

    <!-- Triangular shape explanation -->
    <div class="space-y-2">
      <div class="flex items-center gap-2">
        <div class="w-1 h-3.5 rounded-full" style="background: #06C8FF"></div>
        <h2 class="text-sm font-bold uppercase tracking-wide text-foreground">
          {{ $t('report.members_retention_info.shape_title') }}
        </h2>
      </div>
      <p class="text-xs text-muted-foreground leading-relaxed ml-3">
        {{ $t('report.members_retention_info.shape_desc') }}
      </p>
    </div>

    <!-- How to use -->
    <div class="space-y-2">
      <div class="flex items-center gap-2">
        <div class="w-1 h-3.5 rounded-full" style="background: #06C8FF"></div>
        <h2 class="text-sm font-bold uppercase tracking-wide text-foreground">
          {{ $t('report.members_retention_info.usage_title') }}
        </h2>
      </div>
      <p class="text-xs text-muted-foreground leading-relaxed ml-3">
        {{ $t('report.members_retention_info.usage_desc') }}
      </p>
    </div>

    <!-- Note -->
    <div class="space-y-2">
      <div class="flex items-center gap-2">
        <div class="w-1 h-3.5 rounded-full" style="background: #06C8FF"></div>
        <h2 class="text-sm font-bold uppercase tracking-wide text-foreground">
          {{ $t('report.members_retention_info.note_label') }}
        </h2>
      </div>
      <p class="text-xs text-muted-foreground leading-relaxed ml-3">
        {{ $t('report.members_retention_info.note') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
// Content-only component — no props needed.
// Injected into a BottomSheet from CenterMembersReport.
</script>
